<template>
  <div class="rs1">
    <header class="rs1__hero" v-if="showSegmentType == 'starten'">
      <div class="rs1__eyebrow">
        <span class="rs1__dot"></span>WaizmannVergleich / SCHRITT 1 VON 2
      </div>
      <h2 class="rs1__title">Neue Berechnung starten</h2>
      <p class="rs1__sub">inkl. AntragAnnahmecheck</p>
      <ul class="hl-list" v-if="!sharedDataStore.isMobile()">
        <li>Welche Tarife abschließbar sind (<b>AntragAnnahmecheck</b>) — 100 % anonym.</li>
        <li>Welche <strong>Zahnzusatzversicherung</strong> am besten für Sie geeignet ist.</li>
        <li><b>Wie viel die besten Tarife kosten</b> und wie diese getestet wurden.</li>
      </ul>
    </header>

    <header class="rs1__hero rs1__hero--blue" v-if="showSegmentType == 'erwachsene'">
      <div class="rs1__eyebrow rs1__eyebrow--invert">
        <span class="rs1__dot rs1__dot--invert"></span>WaizmannVergleich / ERWACHSENE
      </div>
      <h2 class="rs1__title rs1__title--invert">Vergleich Erwachsene</h2>
      <p class="rs1__sub rs1__sub--invert">Zahnzusatzversicherung</p>
      <p class="rs1__lead" v-if="!sharedDataStore.isMobile()">
        Sie erhalten <strong class="text-green">jetzt sofort</strong> eine
        detaillierte Auswertung der besten Zahnzusatzversicherungen.
      </p>
    </header>

    <header class="rs1__hero rs1__hero--yellow" v-if="showSegmentType == 'zahnkind'">
      <div class="rs1__eyebrow">
        <span class="rs1__dot rs1__dot--yellow"></span>WaizmannVergleich / KIND
      </div>
      <h2 class="rs1__title">Neue Berechnung „Kind" starten</h2>
      <p class="rs1__sub">inkl. AntragAnnahmecheck</p>
      <p class="rs1__lead" v-if="!sharedDataStore.isMobile()">
        Sie erhalten <strong class="text-green">jetzt sofort</strong> eine
        detaillierte Auswertung der besten Kinder-Zahnzusatzversicherungen mit
        Schwerpunkt Kieferorthopädie. Der <b>AntragAnnahmecheck</b> wird 100 %
        anonym durchgeführt.
      </p>
    </header>

    <header class="rs1__hero rs1__hero--purple" v-if="showSegmentType == 'zahnplus'">
      <div class="rs1__eyebrow">
        <span class="rs1__dot rs1__dot--purple"></span>WaizmannVergleich / 60 PLUS
      </div>
      <h2 class="rs1__title">Neue Berechnung „60 Plus" starten</h2>
      <p class="rs1__sub">inkl. AntragAnnahmecheck</p>
      <p class="rs1__lead" v-if="!sharedDataStore.isMobile()">
        Sie erhalten <strong class="text-green">jetzt sofort</strong> eine
        detaillierte Auswertung der besten Zahnzusatzversicherungen — Schwerpunkt
        Zahnersatz, Prothetik und Zahnerhalt. Der <b>AntragAnnahmecheck</b> wird
        100 % anonym durchgeführt.
      </p>
    </header>

    <header class="rs1__hero rs1__hero--orange" v-if="showSegmentType == 'brille'">
      <div class="rs1__eyebrow">
        <span class="rs1__dot rs1__dot--orange"></span>WaizmannVergleich / BRILLE
      </div>
      <h2 class="rs1__title">Neue Berechnung starten — Brille &amp; Sehhilfe</h2>
      <p class="rs1__lead" v-if="!sharedDataStore.isMobile()">
        <strong>In 30 Sekunden erhalten Sie:</strong>
      </p>
      <ul class="hl-list" v-if="!sharedDataStore.isMobile()">
        <li>den Brillen-Tarif, der für Sie am besten geeignet ist</li>
        <li>eine detaillierte Tarifanalyse (Testbericht)</li>
        <li>einen Online-Vorab-Annahme-Check</li>
      </ul>
    </header>

    <header class="rs1__hero rs1__hero--turk" v-if="showSegmentType == 'heilpraktiker'">
      <div class="rs1__eyebrow">
        <span class="rs1__dot rs1__dot--turk"></span>WaizmannVergleich / HEILPRAKTIKER
      </div>
      <h2 class="rs1__title">Neue Berechnung starten — Heilpraktiker</h2>
      <p class="rs1__lead" v-if="!sharedDataStore.isMobile()">
        <strong>In 30 Sekunden erhalten Sie:</strong>
      </p>
      <ul class="hl-list" v-if="!sharedDataStore.isMobile()">
        <li>den Heilpraktiker-Tarif, der für Sie am besten geeignet ist</li>
        <li>eine detaillierte Tarifanalyse (Testbericht)</li>
        <li>einen Online-Vorab-Annahme-Check</li>
      </ul>
    </header>

    <header class="rs1__hero rs1__hero--cyan" v-if="showSegmentType == 'krankenhaus'">
      <div class="rs1__eyebrow">
        <span class="rs1__dot rs1__dot--cyan"></span>WaizmannVergleich / KRANKENHAUS
      </div>
      <h2 class="rs1__title">Neue Berechnung starten — Krankenhaus</h2>
      <p class="rs1__lead" v-if="!sharedDataStore.isMobile()">
        <strong>In 30 Sekunden erhalten Sie:</strong>
      </p>
      <ul class="hl-list" v-if="!sharedDataStore.isMobile()">
        <li>die Krankenhaus-Zusatzversicherung, die für Sie am besten geeignet ist</li>
        <li>eine detaillierte Tarifanalyse (Testbericht)</li>
        <li>einen Online-Vorab-Annahme-Check</li>
      </ul>
    </header>

    <v-form
      ref="berechnungFormRef"
      v-show="!berechnung_submited"
      @submit.prevent="submitBerechnung"
      class="rs1__form"
    >
      <section class="qrow qrow--birth">
        <div class="qrow__title">
          Ihr <b>Geburtstag</b>
          <span v-if="berechnung.ber_erst == 1" class="qrow__sub">
            <a @click="resetAll()">neue Person berechnen</a>
          </span>
        </div>
        <div class="qrow__input">
          <input-geburtstag-select
            :key="componentKeyStatus"
            v-on:update:year="yearChanged"
            v-on:update:month="monthChanged"
            v-on:update:day="dayChanged"
            :year="berechnung.ber_jahr"
            :month="berechnung.ber_monat"
            :day="berechnung.ber_tag"
          />
        </div>
      </section>

      <div
        v-if="showKfoInfo && berechnung.ber_segment < 2"
        class="qnote qnote--orange"
      >
        <h3 class="qnote__title">Tarife mit Leistung für Kieferorthopädie?</h3>
        <p>
          Soll die gesuchte Zahnzusatzversicherung noch für Kieferorthopädie /
          Zahnspangen leisten, oder benötigen Sie das nicht mehr?
        </p>
        <wtb-check-box
          label-data="Kieferorthopädie soll mitversichert werden"
          :input="berechnung.ber_kfoja"
          @update:input="updateValueBer('ber_kfoja', $event)"
        />
        <p class="qnote__hint">
          <b>Wichtig:</b> Eine Versicherung mit Leistungen für Zahnspangen können
          Sie nur dann abschließen, wenn aktuell noch keine Zahnfehlstellung bei
          Ihrem Kind diagnostiziert worden ist.
        </p>
      </div>

      <section class="qrow">
        <div class="qrow__title">Ihr <b>Geschlecht</b></div>
        <div class="qrow__input">
          <v-btn-toggle
            v-model="berechnung.ber_geschlecht"
            mandatory
            divided
            rounded="0"
            color="primary"
            class="qtoggle"
          >
            <v-btn :value="0">Frau</v-btn>
            <v-btn :value="1">Mann</v-btn>
          </v-btn-toggle>
        </div>
      </section>

      <section class="qrow">
        <div class="qrow__title">Wie sind Sie <b>versichert</b>?</div>
        <div class="qrow__input">
          <v-select
            v-model="berechnung.ber_gesetzl"
            :items="versicherungsArten"
            item-value="id"
            item-title="name"
            single-line
          />
          <span v-if="berechnung.ber_segment < 2" class="qrow__hint">
            <wtb-check-box
              label-data="möchte Zahnversicherung wechseln"
              @change="showTarifSuche()"
              :input="berechnung.ber_wechsel"
              @update:input="updateValueBer('ber_wechsel', $event)"
            />
          </span>
        </div>
      </section>

      <v-alert
        v-show="berechnung.ber_gesetzl == '2' && berechnung.ber_segment < 2"
        type="info"
        variant="tonal"
        rounded="0"
        density="comfortable"
        class="qalert"
        closable
      >
        Wenn Sie in der PKV (privaten Krankenversicherung) versichert sind, können
        Sie keine „normale" Zahnzusatzversicherung beantragen.
      </v-alert>

      <div v-if="showSegmentType == 'brille' || showSegmentType == 'heilpraktiker'">
        <berechnung-form-row>
          <template v-slot:title>
            <div>
              Haben Sie bereits eine <strong>Sehhilfe</strong> oder ist eine solche
              angeraten?
            </div>
          </template>
          <template v-slot:input>
            <v-btn-toggle
              v-model="berechnung.ber_brille_ja"
              mandatory
              divided
              rounded="0"
              color="primary"
              class="qtoggle"
              @update:modelValue="resetSehhilfe()"
            >
              <v-btn :value="1">Ja</v-btn>
              <v-btn :value="0">Nein</v-btn>
            </v-btn-toggle>
          </template>
        </berechnung-form-row>
      </div>

      <div v-if="showSegmentType == 'heilpraktiker' || showSegmentType == 'krankenhaus'">
        <berechnung-form-row>
          <template v-slot:title>
            Haben Sie <strong>chronische Erkrankungen</strong> oder
            <strong>schwere Vorerkrankungen</strong>?
            <div class="qrow__hint">
              <a @click="showBerChronisch = !showBerChronisch">
                Welche Art von Krankheiten zählen darunter …
              </a>
            </div>
          </template>
          <template v-slot:input>
            <v-btn-toggle
              v-model="berechnung.ber_top_gesund"
              mandatory
              divided
              rounded="0"
              color="primary"
              class="qtoggle"
            >
              <v-btn :value="1">Ja</v-btn>
              <v-btn :value="0">Nein</v-btn>
            </v-btn-toggle>
          </template>
        </berechnung-form-row>
        <v-alert
          closable
          rounded="0"
          density="comfortable"
          variant="tonal"
          color="primary"
          v-if="showBerChronisch"
          type="info"
          class="qalert"
        >
          <ul class="hl-list">
            <li>
              Erkrankungen des Nervensystems, des Gehirns, der Psyche, des Herzens,
              der Gefäße, der Lunge, der Leber, der Bauchspeicheldrüse, des Magens,
              des Darms, des Blutes, des Kreislaufs, der Harn- und
              Geschlechtsorgane, des Stoffwechsels, der Haut, der Muskeln, Knochen
              oder Gelenke
            </li>
            <li>eine Krebserkrankung</li>
            <li>eine Suchterkrankung</li>
            <li>eine HIV-Infektion</li>
          </ul>
        </v-alert>
      </div>

      <div v-if="showSegmentType == 'brille'">
        <berechnung-form-row v-if="berechnung.ber_brille_ja == 1">
          <template v-slot:title>
            Haben Sie neben einer eventuellen Sehschwäche
            <strong>weitere Augenkrankheiten</strong>?
          </template>
          <template v-slot:input>
            <v-btn-toggle
              v-model="berechnung.ber_brille_krankheit"
              mandatory
              divided
              rounded="0"
              color="primary"
              class="qtoggle"
            >
              <v-btn :value="1">Ja</v-btn>
              <v-btn :value="0">Nein</v-btn>
            </v-btn-toggle>
          </template>
        </berechnung-form-row>

        <berechnung-form-row>
          <template v-slot:title>
            Möchten Sie eine <strong>Sonnenbrille mit Sehstärke</strong>
            mitversichern?
          </template>
          <template v-slot:input>
            <v-btn-toggle
              v-model="berechnung.ber_brille_sonnenbrille"
              mandatory
              divided
              rounded="0"
              color="primary"
              class="qtoggle"
            >
              <v-btn :value="1">Ja</v-btn>
              <v-btn :value="0">Nein</v-btn>
            </v-btn-toggle>
          </template>
        </berechnung-form-row>

        <berechnung-form-row>
          <template v-slot:title>
            Haben Sie bereits eine <b>Gleitsichtbrille</b> oder planen eine
            Gleitsichtbrille zu benutzen?
          </template>
          <template v-slot:input>
            <v-btn-toggle
              v-model="berechnung.ber_brille_gleitsicht"
              mandatory
              divided
              rounded="0"
              color="primary"
              class="qtoggle"
            >
              <v-btn :value="1">Ja</v-btn>
              <v-btn :value="0">Nein</v-btn>
            </v-btn-toggle>
          </template>
        </berechnung-form-row>

        <berechnung-form-row>
          <template v-slot:title>
            Möchten Sie <strong>Augenlaser-Operationen (Lasik)</strong>
            mitversichern?
          </template>
          <template v-slot:input>
            <v-btn-toggle
              v-model="berechnung.ber_brille_lasik"
              mandatory
              divided
              rounded="0"
              color="primary"
              class="qtoggle"
            >
              <v-btn :value="1">Ja</v-btn>
              <v-btn :value="0">Nein</v-btn>
            </v-btn-toggle>
          </template>
        </berechnung-form-row>

        <berechnung-form-row>
          <template v-slot:title>
            Möchten Sie ein <strong>Hörgerät</strong> mitversichern?
          </template>
          <template v-slot:input>
            <v-btn-toggle
              v-model="berechnung.ber_hoergeraet_versicherung"
              mandatory
              divided
              rounded="0"
              color="primary"
              class="qtoggle"
              @update:modelValue="resetSehhilfe()"
            >
              <v-btn :value="1">Ja</v-btn>
              <v-btn :value="0">Nein</v-btn>
            </v-btn-toggle>
          </template>
        </berechnung-form-row>

        <berechnung-form-row v-if="berechnung.ber_hoergeraet_versicherung == 1">
          <template v-slot:title>
            Tragen Sie eine Hörhilfe oder ist eine Hörgeräteversorgung angeraten?
          </template>
          <template v-slot:input>
            <v-btn-toggle
              v-model="berechnung.ber_hoergeraet_massnahme"
              mandatory
              divided
              rounded="0"
              color="primary"
              class="qtoggle"
            >
              <v-btn :value="1">Ja</v-btn>
              <v-btn :value="0">Nein</v-btn>
            </v-btn-toggle>
          </template>
        </berechnung-form-row>
      </div>

      <div v-if="berechnung.ber_segment < 2">
        <section class="qrow">
          <div class="qrow__title">
            <b>Ihre Postleitzahl?</b>
            <p class="qrow__hint">
              Bitte geben Sie die Postleitzahl Ihres Wohnortes <b>5-stellig</b>
              ein. Einige Tarife gewähren je nach Wohnort einen günstigeren
              Beitrag.
            </p>
          </div>
          <div class="qrow__input">
            <v-text-field
              maxlength="5"
              minlength="5"
              v-model="berechnung.ber_plz"
            />
          </div>
        </section>

        <section class="qrow">
          <div class="qrow__title">
            Läuft gerade eine <strong>zahnärztliche Behandlung</strong> oder wurde
            empfohlen?
            <p class="qrow__hint">
              außer Aufbiss-Schienen und prof. Zahnreinigung (PZR)
              <a v-on:click="showBerZahnmassInfo = !showBerZahnmassInfo">
                Erklärung anzeigen
              </a>
            </p>
          </div>
          <div class="qrow__input">
            <v-btn-toggle
              v-model="berechnung.ber_zahnmass"
              mandatory
              divided
              rounded="0"
              color="primary"
              class="qtoggle"
              @update:modelValue="berMassnahmeChanged($event)"
            >
              <v-btn :value="1">Ja</v-btn>
              <v-btn :value="0">Nein</v-btn>
            </v-btn-toggle>
          </div>
        </section>

        <v-alert
          closable
          rounded="0"
          density="comfortable"
          variant="tonal"
          color="primary"
          v-if="showBerZahnmassInfo"
          type="info"
          class="qalert"
        >
          <zahnmass-info class="body-2" />
        </v-alert>

        <div
          v-show="berechnung.ber_zahnmass == 1 && berechnung.ber_alter > 17"
          class="qsub"
        >
          <section class="qrow">
            <div class="qrow__title">
              Soll diese Behandlung von Ihrer Versicherung
              <b>bereits bezahlt</b> werden? (gegen Aufschlag möglich)
            </div>
            <div class="qrow__input">
              <v-btn-toggle
                v-model="berechnung.ber_sofort"
                mandatory
                divided
                rounded="0"
                color="primary"
                class="qtoggle"
              >
                <v-btn :value="1">Ja</v-btn>
                <v-btn :value="0">Nein</v-btn>
              </v-btn-toggle>
            </div>
          </section>
        </div>

        <section class="qrow">
          <div class="qrow__title">
            Haben Sie eine <strong>Aufbiss-</strong> bzw.
            <strong>Zahnschiene</strong>?
            <p class="qrow__hint">
              <a v-on:click="showBerAufbissInfo = !showBerAufbissInfo">
                Detaillierte Erklärung …
              </a>
            </p>
          </div>
          <div class="qrow__input">
            <v-btn-toggle
              v-model="berechnung.ber_aufbiss"
              mandatory
              divided
              rounded="0"
              color="primary"
              class="qtoggle"
            >
              <v-btn :value="1">Ja</v-btn>
              <v-btn :value="0">Nein</v-btn>
            </v-btn-toggle>
          </div>
        </section>

        <v-alert
          closable
          rounded="0"
          density="comfortable"
          variant="tonal"
          color="primary"
          v-if="showBerAufbissInfo"
          type="info"
          class="qalert"
        >
          <aufbiss-info class="body-2" />
        </v-alert>

        <section class="qrow">
          <div class="qrow__title">
            Besteht eine <strong>ärztlich festgestellte Zahnfehlstellung</strong>?
            <p class="qrow__hint">
              Wurde bereits eine kieferorthopädische Behandlung empfohlen?
              <a v-on:click="showBerZahnfehlInfo = !showBerZahnfehlInfo">
                Ausführliche Erklärung …
              </a>
            </p>
          </div>
          <div class="qrow__input">
            <v-btn-toggle
              v-model="berechnung.ber_zahnfehl"
              mandatory
              divided
              rounded="0"
              color="primary"
              class="qtoggle"
            >
              <v-btn :value="1">Ja</v-btn>
              <v-btn :value="0">Nein</v-btn>
            </v-btn-toggle>
          </div>
        </section>

        <v-alert
          closable
          rounded="0"
          density="comfortable"
          variant="tonal"
          color="primary"
          v-if="showBerZahnfehlInfo"
          type="info"
          class="qalert"
        >
          <zahnfehl-info class="body-2" />
        </v-alert>

        <section class="qrow" v-if="berechnung.ber_alter > 6">
          <div class="qrow__title">
            Wurde bei Ihnen bereits eine <strong>Parodontosebehandlung</strong>
            durchgeführt?
            <p class="qrow__hint">
              <a v-on:click="showBerZb3Info = !showBerZb3Info">
                Mehr Infos anzeigen …
              </a>
            </p>
          </div>
          <div class="qrow__input">
            <v-btn-toggle
              v-model="berechnung.ber_zb_3"
              mandatory
              divided
              rounded="0"
              color="primary"
              class="qtoggle"
            >
              <v-btn :value="1">Ja</v-btn>
              <v-btn :value="0">Nein</v-btn>
            </v-btn-toggle>
          </div>
        </section>

        <v-alert
          closable
          rounded="0"
          density="comfortable"
          variant="tonal"
          color="primary"
          v-if="showBerZb3Info"
          type="info"
          class="qalert"
        >
          <zb3-info class="body-2" />
        </v-alert>

        <section class="qrow" v-if="berechnung.ber_alter > 6">
          <div class="qrow__title">
            Haben Sie <b>fehlende</b> oder <b>ersetzte</b> Zähne?
            <p class="qrow__hint">
              <b class="text-green">Ersetzte Zähne sind z. B.:</b>
              Kronen, Implantate, Veneers, Prothesen und Brücken — bitte mit
              „<b>ja</b>" beantworten.
              <br />
              <b>Fehlende Zähne sind nicht:</b>
              Weisheitszähne, Milchzähne, sog. „Lückenschlüsse" — bitte mit
              „<b>nein</b>" beantworten.
            </p>
          </div>
          <div class="qrow__input">
            <v-btn-toggle
              v-model="berechnung.ber_ze_ja"
              mandatory
              divided
              rounded="0"
              color="primary"
              class="qtoggle"
              @update:modelValue="berZeChanged($event)"
            >
              <v-btn :value="1">Ja</v-btn>
              <v-btn :value="0">Nein</v-btn>
            </v-btn-toggle>
          </div>
        </section>

        <div
          v-show="
            (berechnung.ber_ze_ja == 1 || berechnung.ber_luecke > 0) &&
            berechnung.ber_alter > 6
          "
          class="qsub"
        >
          <berechnung-form-row>
            <template v-slot:title>
              <div>
                Wie viele <strong>Zähne fehlen</strong> Ihnen, die nicht ersetzt
                wurden, oder sind bereits zum Ziehen angeraten?
              </div>
              <div class="qrow__hint">
                Der Rechner sucht Tarife, die
                <strong>fehlende Zähne mitversichern.</strong>
                <br />
                <a v-on:click="showBerLueckeInfo = !showBerLueckeInfo">
                  Mehr Infos …
                </a>
              </div>
            </template>
            <template v-slot:input>
              <v-select
                v-model="berechnung.ber_luecke"
                :items="berLueckeSelect"
                item-title="name"
                item-value="id"
                single-line
                @update:modelValue="berLueckeChanged"
              />
            </template>
          </berechnung-form-row>

          <v-alert
            closable
            rounded="0"
            density="comfortable"
            variant="tonal"
            color="primary"
            v-if="showBerLueckeInfo"
            type="info"
            class="qalert"
          >
            <luecke-info class="body-2" />
          </v-alert>

          <berechnung-form-row v-if="berechnung.ber_luecke != 0">
            <template v-slot:title>
              <div>
                Wollen Sie bereits bestehende Lücken
                <strong class="text-green">mitversichern</strong>?
                <span
                  class="qrow__hint"
                  v-if="berechnung.ber_luecke > 0 && berechnung.ber_luecke < 3"
                >
                  <br />Bei einem fehlenden Zahn empfehlen wir Ihnen,
                  <strong class="text-green">diesen zu versichern</strong>. Dies
                  ist oft kostenlos möglich. Bei mehreren fehlenden Zähnen
                  teilweise mit Aufschlag möglich.
                </span>
              </div>
            </template>
            <template v-slot:input>
              <wtb-check-box
                label-data="Ja"
                :input="berechnung.ber_luecke_vers"
                @update:input="updateValueBer('ber_luecke_vers', $event)"
              />
            </template>
          </berechnung-form-row>

          <berechnung-form-row>
            <template v-slot:title>
              <div>
                Anzahl der durch herausnehmbare <strong>Prothesen</strong>
                ersetzten Zähne?
                <p class="qrow__hint">
                  <a v-on:click="showBerZahnersetztInfo = !showBerZahnersetztInfo">
                    Mehr Infos dazu …
                  </a>
                </p>
              </div>
            </template>
            <template v-slot:input>
              <v-select
                v-model="berechnung.ber_zahnersetzt"
                :items="berLueckeSelect"
                item-title="name"
                item-value="id"
                single-line
              />
            </template>
          </berechnung-form-row>

          <berechnung-form-row
            v-if="
              berechnung.ber_zahnersetzt != 0 ||
              berechnung.ber_bruecke != 0 ||
              berechnung.ber_kronen != 0
            "
          >
            <template v-slot:title>
              <div>
                Haben Sie ersetzte Zähne / Prothesen, die älter als 10 Jahre sind?
              </div>
            </template>
            <template v-slot:input>
              <wtb-check-box
                label-data="Ja"
                :input="berechnung.ber_zahnersatz_10"
                @update:input="updateValueBer('ber_zahnersatz_10', $event)"
              />
            </template>
          </berechnung-form-row>

          <v-alert
            closable
            rounded="0"
            density="comfortable"
            variant="tonal"
            color="primary"
            v-if="showBerZahnersetztInfo"
            type="info"
            class="qalert"
          >
            <zahnersetzt-info class="body-2" />
          </v-alert>

          <berechnung-form-row>
            <template v-slot:title>
              <div>
                Wie viele <strong>Brücken</strong> haben Sie?
                <p class="qrow__hint">
                  <a v-on:click="showBerBrueckeInfo = !showBerBrueckeInfo">
                    Erklärung anzeigen
                  </a>
                </p>
              </div>
            </template>
            <template v-slot:input>
              <v-select
                v-model="berechnung.ber_bruecke"
                :items="berLueckeSelect"
                item-title="name"
                item-value="id"
                single-line
              />
            </template>
          </berechnung-form-row>

          <v-alert
            closable
            rounded="0"
            density="comfortable"
            variant="tonal"
            color="primary"
            v-if="showBerBrueckeInfo"
            type="info"
            class="qalert"
          >
            <bruecke-info class="body-2" />
          </v-alert>

          <berechnung-form-row>
            <template v-slot:title>
              <div>
                Wie viele (Teil-)<strong>Kronen</strong> und
                <strong>Implantate</strong> haben Sie?
                <p class="qrow__hint">
                  <a v-on:click="showBerKronenInfo = !showBerKronenInfo">
                    Detail-Infos anzeigen
                  </a>
                </p>
              </div>
            </template>
            <template v-slot:input>
              <v-select
                v-model="berechnung.ber_kronen"
                :items="berLueckeSelect"
                item-title="name"
                item-value="id"
                single-line
              />
            </template>
          </berechnung-form-row>

          <v-alert
            closable
            rounded="0"
            density="comfortable"
            variant="tonal"
            color="primary"
            v-if="showBerKronenInfo"
            type="info"
            class="qalert"
          >
            <kronen-info class="body-2" />
          </v-alert>
        </div>
      </div>

      <section class="rs1__erst" v-if="berechnung.ber_erst == 0">
        <div class="rs1__erst-check">
          <v-checkbox
            color="primary"
            @click="erstInfoChecked()"
            :rules="validateCheckbox()"
            hide-details
          />
        </div>
        <div class="rs1__erst-text">
          <h3>
            <span class="text-green">Ja,</span> ich habe die Erstinformation für
            Kunden erhalten
          </h3>
          <p>
            <a @click="erstInfoChecked()">
              Erstinformationen für Versicherungsmakler
            </a>
            gemäß § 15 VersVermV
            <a @click="berechnungStore.setShowPopApp('erstinfopop')">
              jetzt anzeigen oder herunterladen.
            </a>
          </p>
          <p v-if="errorMessage" class="text-orange">{{ errorMessage }}</p>
        </div>
      </section>

      <div
        class="qnote qnote--err"
        v-if="berechnung.ber_erst == 0 && berErstError"
      >
        <h3 class="qnote__title">
          Bitte setzen Sie den Haken auf „Ja", um eine Berechnung zu starten.
        </h3>
      </div>

      <div
        class="qnote"
        v-if="
          sucheTarife &&
          berechnung.ber_segment <= 1 &&
          berechnung.ber_wechsel == 1
        "
      >
        <h3 class="qnote__title">
          <span class="text-green">Optional:</span>
          welche Zahnzusatzversicherungen haben Sie bis jetzt?
        </h3>
        <v-text-field
          v-model="search"
          type="text"
          label="Name Ihrer Zahnzusatzversicherung (die Sie wechseln wollen)"
        />
        <span v-if="filteredTarife && search">
          <p>
            <b>Wählen Sie jetzt Ihre Zahnzusatzversicherung aus (wenn möglich)</b>
          </p>
          <v-radio-group v-model="berechnung.ber_wechsel_tarif_id">
            <v-radio
              @click="setWechselTarif(tarif.tarif_id, tarif.tarif_name)"
              v-for="tarif in filteredTarife"
              :key="`tarifsuche${tarif.tarif_id}`"
              :value="tarif.tarif_id"
              :label="tarif.tarif_name"
            />
          </v-radio-group>
        </span>
      </div>

      <div class="qnote qnote--err" v-if="showGeburtstagFehler">
        <h3 class="qnote__title">Bitte geben Sie ein Geburtsdatum an.</h3>
      </div>

      <section class="rs1__submit">
        <div class="rs1__submit-extra">
          <wtb-check-box
            v-if="
              berechnung.ber_erst == 1 &&
              berechnung.ber_segment <= 1 &&
              berechnung.ber_alter > 17
            "
            label-data="wollen Sie Bleaching mitversichern?"
            :input="berechnung.ber_bleaching"
            @update:input="updateValueBer('ber_bleaching', $event)"
          />
        </div>
        <v-btn
          color="primary"
          size="large"
          type="submit"
          class="rs1__submit-btn"
          append-icon="mdi-arrow-right-circle"
        >
          <span v-if="!sharedDataStore.isMobile()">
            Vergleich starten — jetzt hier klicken
          </span>
          <span v-else>Vergleich starten</span>
        </v-btn>
      </section>

      <section class="rs1__hints">
        <h3>Der Rechner zeigt Ihnen sofort:</h3>
        <ul class="hl-list" v-if="berechnung.ber_segment == 2">
          <li>die leistungstärksten Zusatzversicherungen für Sehhilfen</li>
        </ul>
        <ul class="hl-list" v-if="berechnung.ber_segment == 3">
          <li>die leistungstärksten Heilpraktiker-Zusatzversicherungen</li>
        </ul>
        <ul class="hl-list" v-if="berechnung.ber_segment == 4">
          <li>die leistungstärksten Krankenhaus-Zusatzversicherungen</li>
        </ul>
        <ul class="hl-list" v-if="berechnung.ber_segment < 2">
          <li v-if="wechselTarifName">
            Sie wollen diesen Tarif wechseln:
            <strong class="text-green">{{ wechselTarifName }}</strong>
          </li>
          <li v-show="berechnung.ber_alter < 9">
            die leistungstärksten Zahnzusatzversicherungen für Kinder |
            <strong class="text-green">{{ berechnung.ber_alter }} Jahre</strong>
          </li>
          <li v-show="berechnung.ber_alter >= 9 && berechnung.ber_alter < 18">
            die leistungstärksten Zahnzusatzversicherungen für Jugendliche |
            <strong class="text-green">{{ berechnung.ber_alter }} Jahre</strong>
          </li>
          <li
            v-show="
              berechnung.ber_luecke_vers == 1 &&
              berechnung.ber_luecke > 0 &&
              berechnung.ber_alter > 18
            "
          >
            Tarife, die bereits fehlende Zähne mitversichern
          </li>
          <li v-show="berechnung.ber_kfoja == '1'">
            Tarife mit möglichst hohen Kieferorthopädie-Leistungen
          </li>
          <li v-show="berechnung.ber_alter >= 18">
            die leistungstärksten Zahnzusatzversicherungen | Eintrittsalter:
            <strong class="text-green">{{ berechnung.ber_alter }} Jahre</strong>
          </li>
          <li v-show="berechnung.ber_alter >= 60">
            die besten Zahnzusatzversicherungen mit möglichst hohen Leistungen für
            Prothetik, Implantate und Zahnersatz.
          </li>
          <li>
            Zahnzusatzversicherungen mit dem besten Preis-Leistungs-Verhältnis
          </li>
          <li v-show="berechnung.ber_zahnmass == 1">
            Tarife, die Sie <strong>trotz laufender Behandlung</strong> beantragen
            können
          </li>
          <li v-show="berechnung.ber_zahnfehl == 1">
            Tarife, die Sie <strong>auch mit einer Zahnfehlstellung</strong>
            beantragen können
          </li>
          <li v-show="berechnung.ber_zb_3 == 1">
            Tarife, die Sie <strong>trotz laufender Parodontose</strong>
            beantragen können
          </li>
          <li v-show="berechnung.ber_aufbiss == 1">
            Tarife, die <strong class="text-green">Aufbiss-Schienen</strong>
            mitversichern
          </li>
        </ul>
      </section>
    </v-form>
    <div v-if="appLoaded" id="appLoaded"></div>
  </div>
</template>

<script setup>
  import {
    ref,
    reactive,
    getCurrentInstance,
    watchEffect,
    computed,
    onMounted,
    defineEmits,
    watch,
  } from "vue";
  import WtbCheckBox from "@/components/berechnung/form/WtbCheckBox";
  import BerechnungFormRow from "@/components/berechnung/form/BerechnungFormRow";
  import InputGeburtstagSelect from "@/components/berechnung/form/InputFormGeburtstagSelect";
  import ZahnmassInfo from "@/components/berechnung/info/ZahnmassInfo";
  import AufbissInfo from "@/components/berechnung/info/AufbissInfo";
  import ZahnfehlInfo from "@/components/berechnung/info/ZahnfehlInfo";
  import Zb3Info from "@/components/berechnung/info/Zb3Info";
  import LueckeInfo from "@/components/berechnung/info/LueckeInfo";
  import ZahnersetztInfo from "@/components/berechnung/info/ZahnersetztInfo";
  import BrueckeInfo from "@/components/berechnung/info/BrueckeInfo";
  import KronenInfo from "@/components/berechnung/info/KronenInfo";

  import { useBerechnungStore } from "@/stores/berechnung";
  import { useSharedDataStore } from "@/stores/sharedData";
  import { useGuestStore } from "@/stores/guest";
  import { useRoute } from "vue-router";
  import BaseCalls from "@/services/BaseCalls";

  const guestStore = useGuestStore();
  const sharedDataStore = useSharedDataStore();
  const emit = defineEmits(["updateBerechnung"]);
  const route = useRoute();
  const berechnungStore = useBerechnungStore();
  const { proxy } = getCurrentInstance();
  const showBerChronisch = ref(false);
  const showBerZahnmassInfo = ref(false);
  const showBerAufbissInfo = ref(false);
  const showBerZahnfehlInfo = ref(false);
  const showBerZb3Info = ref(false);
  const showBerLueckeInfo = ref(false);
  const showBerZahnersetztInfo = ref(false);
  const showBerBrueckeInfo = ref(false);
  const showBerKronenInfo = ref(false);
  const showKfoInfo = ref(false);
  const componentKeyStatus = ref(0);
  const routeSegment = ref(1);
  const appLoaded = ref(true);
  const showGeburtstagFehler = ref(false);
  const berechnung = reactive({
    ber_guest_id: 0,
    ber_rechner_type: 1,
    ber_wechsel_tarif_id: 0,
    ber_annahme_tarif_id: 0,
    ber_kunden_id: "0",
    ber_segment: 1,
    ber_wechsel: 0,
    ber_alter: 0,
    ber_plz: "",
    ber_aufbiss: 0,
    ber_bruecke: 0,
    ber_bleaching: 0,
    ber_kronen: 0,
    ber_geschlecht: 1,
    ber_gesetzl: 1,
    ber_zahnmass: 0,
    ber_zahnmass_2: 1,
    ber_sofort: 0,
    ber_tag: new Date().getDate(),
    ber_monat: new Date().getMonth() + 1,
    ber_jahr: new Date().getFullYear(),
    ber_zb_3: 0,
    ber_zahnfehl: 0,
    ber_ze_ja: 0,
    ber_luecke: 0,
    ber_luecke_vers: 0,
    ber_zahnersetzt: 0,
    ber_zahnersatz_10: 0,
    ber_kfoja: 0,
    ber_screen_size: window.innerWidth,
    ber_erst: 0,
    ber_brille_ja: 0,
    ber_brille_dioptrien: 0,
    ber_brille_krankheit: 0,
    ber_brille_sonnenbrille: 0,
    ber_brille_gleitsicht: 0,
    ber_hoergeraet_versicherung: 0,
    ber_hoergeraet_massnahme: 0,
    ber_brille_lasik: 0,
    ber_top_gesund: 0,
  });

  const defaultValues = reactive({
    ...berechnung,
  });

  const versicherungsArten = ref([
    { id: 1, name: "gesetzliche Krankenkasse" },
    { id: 2, name: "private Krankenversicherung" },
    { id: 3, name: "Heilfürsorge" },
    { id: 4, name: "gesetzliche Krankenkasse & Beihilfe" },
    { id: 5, name: "freie Heilfürsorge & Beihilfe" },
  ]);

  const berLueckeSelect = ref([
    { id: "0", name: "0" },
    { id: "1", name: "1" },
    { id: "2", name: "2" },
    { id: "3", name: "3" },
    { id: "4", name: "4" },
    { id: "5", name: "5" },
    { id: "6", name: "6" },
    { id: "7", name: "7" },
    { id: "8", name: "8" },
    { id: "9", name: "9" },
    { id: "10", name: "10" },
    { id: "11", name: "11" },
    { id: "12", name: "12" },
    { id: "13", name: "13" },
    { id: "14", name: "14" },
    { id: "15", name: "mehr als 14" },
  ]);
  const berechnung_submited = ref(false);
  const wechselTarifName = ref(false);
  const berechnungFormRef = ref(null);
  const sucheTarife = ref([]);
  const search = ref("");
  const isChecked = ref(false);
  const errorMessage = ref("");
  const berErstError = ref(false);

  const resetAll = () => {
    console.log("reset berechnung");
    Object.assign(berechnung, defaultValues);
  };
  const validateCheckbox = () => {
    if (!isChecked.value) {
      errorMessage.value =
        "Sie müssen den Bedingungen zustimmen, um fortzufahren.";
    } else {
      errorMessage.value = "";
    }
  };
  function showTarifSuche() {
    if (berechnung.ber_wechsel == 1) {
      getAlleZahnTarife();
    }
  }
  function checkCurrentDate() {
    const heute = new Date();
    const aktuellesJahr = heute.getFullYear();
    const aktuellerMonat = heute.getMonth() + 1;
    const aktuellerTag = heute.getDate();

    if (
      berechnung.ber_jahr === aktuellesJahr &&
      berechnung.ber_monat === aktuellerMonat &&
      berechnung.ber_tag === aktuellerTag
    ) {
      return true;
    } else {
      return false;
    }
  }
  function checkBerechnung() {
    let checkPassed = true;
    showGeburtstagFehler.value = false;
    if (checkCurrentDate()) {
      showGeburtstagFehler.value = true;
    }
    if (berechnung.ber_erst == 0) {
      checkPassed = false;
      berErstError.value = true;
      console.log("ber_erst check");
    }
    if (berechnungFormRef.value && !berechnungFormRef.value.validate()) {
      checkPassed = false;
      console.log("checkPassfalse");
    }
    console.log("checkPassed" + checkPassed);
    return checkPassed;
  }

  async function getAlleZahnTarife() {
    let select = {};
    select.action = "getAlleZahnTarife";
    try {
      const resp = await BaseCalls.postTarif(select);
      if (resp.data && resp.data.tarife) {
        sucheTarife.value = resp.data.tarife;
      }
    } catch (err) {
      console.log("error tarife");
    }
  }
  async function submitBerechnung() {
    if (!checkBerechnung()) {
      return false;
    }

    berechnung.action = "insertBerechnung";
    berechnung.berGestartet = true;
    berechnung.ber_guest_id = resolveGuestId();
    berechnung.ber_user_id = resolveUserId(berechnung.ber_guest_id);
    console.log("berechnung gestartet");
    try {
      const resp = await BaseCalls.postBerechnung(berechnung);

      if (resp.data && resp.data.berechnung) {
        console.log("insert erfolgreich" + resp.data.berechnung);
        berechnungStore.setBerechnung(resp.data.berechnung);
      }
    } catch (err) {
      console.log("error berechnung");
    }
  }

  // Guest-ID: primaer aus dem Guest-Store, sonst aus der bereits geladenen
  // Berechnung (z.B. Einstieg ueber Token-Link, Guest-Store noch leer).
  function resolveGuestId() {
    const storeGuestId = parseInt(guestStore.guest?.guest_id) || 0;
    if (storeGuestId > 0) {
      return storeGuestId;
    }
    return parseInt(berechnungStore.berechnung?.ber_guest_id) || 0;
  }

  // Vermittler-ID (ber_user_id): Guest-Store -> :userid aus der Route ->
  // letzte Berechnung desselben Gastes. Nie stillschweigend 0 senden, wenn
  // eine Vermittler-Zuordnung bekannt ist.
  function resolveUserId(guestId) {
    const storeUserId = parseInt(guestStore.guest?.guest_user_id) || 0;
    if (storeUserId > 0) {
      return storeUserId;
    }
    const routeUserId = parseInt(route.params.userid) || 0;
    if (routeUserId > 0) {
      return routeUserId;
    }
    const lastBer = berechnungStore.berechnung;
    if (
      lastBer &&
      parseInt(lastBer.ber_user_id) > 0 &&
      guestId > 0 &&
      parseInt(lastBer.ber_guest_id) === guestId
    ) {
      return parseInt(lastBer.ber_user_id);
    }
    return 0;
  }

  const updateValueBer = (key, newValue) => {
    console.log("New: " + newValue);
    berechnung[key] = newValue;
  };
  function resetSehhilfe() {
    if (berechnung.ber_brille_ja == 0) {
      berechnung.ber_brille_krankheit = "0";
    }
    if (berechnung.ber_hoergeraet_versicherung == 0) {
      berechnung.ber_hoergeraet_massnahme = "0";
    }
  }

  const filteredTarife = computed(() => {
    if (sucheTarife.value.length > 1) {
      return sucheTarife.value.filter((tarif) =>
        tarif.tarif_name.toLowerCase().includes(search.value.toLowerCase())
      );
    }
    return [];
  });
  function dayChanged(day) {
    berechnung.ber_tag = day;
    handleBirthdayChanged();
  }
  function monthChanged(month) {
    berechnung.ber_monat = month;
    handleBirthdayChanged();
  }
  function yearChanged(year) {
    berechnung.ber_jahr = year;
    handleBirthdayChanged();
  }

  function handleBirthdayChanged() {
    showGeburtstagFehler.value = false;
    calcAge();

    if (berechnung.ber_alter <= 6) {
      berechnung.ber_luecke = "0";
      berechnung.ber_luecke_vers = "0";
      berechnung.ber_kronen = "0";
      berechnung.ber_ze_ja = "0";
      berechnung.ber_bruecke = "0";
      berechnung.ber_zahnersetzt = "0";
      berechnung.ber_zb_3 = "0";
    }

    if (berechnung.ber_alter <= 9) {
      showKfoInfo.value = false;
      berechnung.ber_kfoja = "1";
    }

    if (berechnung.ber_alter >= 10 && berechnung.ber_alter <= 17) {
      showKfoInfo.value = true;
      berechnung.ber_kfoja = "1";
    }

    if (berechnung.ber_alter >= 18) {
      berechnung.ber_kfoja = "0";
      showKfoInfo.value = false;
    }
  }

  function calcAge() {
    let age = proxy.$calcAge(
      berechnung.ber_tag,
      berechnung.ber_monat,
      berechnung.ber_jahr
    );
    berechnung.ber_alter = age;
  }
  function setWechselTarif(tarif_id, tarif_name) {
    berechnung.ber_wechsel_tarif_id = tarif_id;
    wechselTarifName.value = tarif_name;
  }
  function erstInfoChecked() {
    berechnung.ber_erst = 1;
  }

  function berMassnahmeChanged() {
    if (berechnung.ber_zahnmass == "0") {
      berechnung.ber_sofort = "0";
    }
  }
  function berZeChanged() {
    console.log("berZeChanged");
    if (berechnung.ber_ze_ja == "0") {
      berechnung.ber_luecke = "0";
      berechnung.ber_luecke_vers = "0";
    }
  }

  function berLueckeChanged(value) {
    console.log("berLueckeChanged");
    if (value == 0) {
      berechnung.ber_luecke_vers = 0;
    } else if (value > 0 && value <= 1) {
      berechnung.ber_luecke_vers = 1;
    } else {
      berechnung.ber_luecke_vers = 0;
    }
  }

  const showSegmentType = computed(() => {
    if (route.params.bertype === "heilpraktiker") {
      return "heilpraktiker";
    }
    if (route.params.bertype === "brille") {
      return "brille";
    }
    if (route.params.bertype === "krankenhaus") {
      return "krankenhaus";
    }
    if (route.params.bertype === "kind") {
      return "zahnkind";
    }
    if (route.params.bertype === "60plus") {
      return "zahnplus";
    }

    if (!route.params.bertype) {
      if (berechnung.ber_segment === 2) {
        return "brille";
      } else if (berechnung.ber_segment === 3) {
        return "heilpraktiker";
      } else if (berechnung.ber_segment === 4) {
        return "krankenhaus";
      } else {
        return "starten";
      }
    } else {
      return "starten";
    }
  });

  watchEffect(() => {
    if (berechnungStore.berechnung) {
      componentKeyStatus.value = componentKeyStatus.value + 1;

      Object.keys(berechnungStore.berechnung).forEach((key) => {
        if (key !== "ber_guest_id") {
          berechnung[key] = berechnungStore.berechnung[key];
        }
        if (
          guestStore.guest.guest_id !== 0 &&
          berechnungStore.berechnung["ber_guest_id"] !==
            guestStore.guest.guest_id
        ) {
          berechnung["ber_guest_id"] = guestStore.guest.guest_id;
        } else {
          berechnung["ber_guest_id"] =
            berechnungStore.berechnung["ber_guest_id"];
        }
        console.log(guestStore.guest.guest_id);
      });
      if (berechnung.ber_segment != routeSegment.value) {
        berechnung.ber_segment = routeSegment.value;
      }
    }
  });
  onMounted(() => {
    routeSegment.value = 1;
    if (route.params.bertype == "60plus") {
      routeSegment.value = 1;
    }
    if (route.params.bertype == "erwachsene") {
      routeSegment.value = 1;
    }
    if (route.params.bertype == "kind") {
      routeSegment.value = 1;
    }
    if (route.params.bertype == "brille") {
      routeSegment.value = 2;
    }
    if (route.params.bertype == "heilpraktiker") {
      routeSegment.value = 3;
    }
    if (route.params.bertype == "krankenhaus") {
      routeSegment.value = 4;
    }
    berechnung.ber_segment = routeSegment.value;
  });
  watch(berechnung, (newValue) => {
    emit("updateBerechnung", newValue);
  });
</script>

<style scoped>
  .rs1 {
    width: 100%;
    max-width: 1180px;
    margin: 0 auto;
    padding: 4px 0 20px;
    color: var(--wz-ink-2);
  }

  .rs1__hero {
    background: #fff;
    border: 1px solid var(--wz-border);
    border-left: 3px solid var(--wz-blue);
    padding: 14px 16px;
    margin-bottom: 16px;
  }
  .rs1__hero--blue {
    background: var(--wz-blue);
    border-left: 3px solid var(--wz-blue);
    color: #fff;
  }
  .rs1__hero--yellow {
    border-left-color: var(--wz-yellow);
  }
  .rs1__hero--purple {
    border-left-color: #513b83;
  }
  .rs1__hero--orange {
    border-left-color: var(--wz-orange);
  }
  .rs1__hero--turk {
    border-left-color: var(--wz-turk);
  }
  .rs1__hero--cyan {
    border-left-color: #00bcd4;
  }
  .rs1__eyebrow {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 1.2px;
    text-transform: uppercase;
    color: var(--wz-ink-4);
    display: flex;
    align-items: center;
  }
  .rs1__eyebrow--invert {
    color: rgba(255, 255, 255, 0.85);
  }
  .rs1__dot {
    width: 6px;
    height: 6px;
    background: var(--wz-blue);
    display: inline-block;
    margin-right: 8px;
  }
  .rs1__dot--invert {
    background: #fff;
  }
  .rs1__dot--yellow {
    background: var(--wz-yellow);
  }
  .rs1__dot--purple {
    background: #513b83;
  }
  .rs1__dot--orange {
    background: var(--wz-orange);
  }
  .rs1__dot--turk {
    background: var(--wz-turk);
  }
  .rs1__dot--cyan {
    background: #00bcd4;
  }
  .rs1__title {
    font-size: clamp(18px, 2.2vw, 22px);
    font-weight: 700;
    letter-spacing: -0.2px;
    color: var(--wz-ink);
    line-height: 1.2;
    margin: 4px 0 2px;
  }
  .rs1__title--invert {
    color: #fff !important;
  }
  .rs1__sub {
    font-size: 13px;
    color: var(--wz-ink-5);
    margin: 2px 0 6px;
  }
  .rs1__sub--invert {
    color: rgba(255, 255, 255, 0.85);
  }
  .rs1__lead {
    font-size: 13px;
    color: var(--wz-ink-2);
    margin: 6px 0 0;
    line-height: 1.45;
  }

  .rs1__form {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .qrow {
    display: grid;
    grid-template-columns: minmax(0, 1.6fr) minmax(0, 1fr);
    gap: 16px;
    align-items: start;
    background: #fff;
    border: 1px solid var(--wz-border);
    padding: 12px 14px;
    border-radius: 3px;
  }
  .qrow--birth {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1.6fr);
  }
  .qrow__title {
    font-size: 13.5px;
    color: var(--wz-ink-2);
    line-height: 1.45;
  }
  .qrow__title b {
    color: var(--wz-ink);
  }
  .qrow__sub {
    display: block;
    margin-top: 4px;
    font-size: 12.5px;
  }
  .qrow__hint {
    font-size: 12px;
    color: var(--wz-ink-5);
    margin: 4px 0 0;
    line-height: 1.4;
  }
  .qrow__input {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 6px;
  }
  .qtoggle {
    align-self: start;
  }
  .qtoggle :deep(.v-btn) {
    border-radius: 0 !important;
    text-transform: none;
    font-weight: 600;
    letter-spacing: 0;
    min-width: 78px;
  }

  .qsub {
    border-left: 3px solid var(--wz-orange);
    padding-left: 12px;
    margin-left: 4px;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .qnote {
    background: var(--wz-surface-blue);
    border: 1px solid var(--wz-border-blue);
    border-left: 3px solid var(--wz-blue);
    padding: 10px 14px;
    border-radius: 3px;
    color: var(--wz-ink-2);
    font-size: 13.5px;
    line-height: 1.45;
  }
  .qnote--orange {
    background: var(--wz-orange-bg);
    border-color: var(--wz-rec-border);
    border-left-color: var(--wz-orange);
  }
  .qnote--err {
    background: var(--wz-red-bg);
    border-color: var(--wz-red-border);
    border-left-color: var(--wz-red);
    color: var(--wz-red);
  }
  .qnote__title {
    font-size: 14px !important;
    font-weight: 700;
    color: var(--wz-ink) !important;
    margin: 0 0 6px;
    letter-spacing: 0;
  }
  .qnote__hint {
    margin: 6px 0 0;
    font-size: 12.5px;
    color: var(--wz-ink-5);
  }

  .qalert {
    border-radius: 3px !important;
  }

  .rs1__erst {
    display: grid;
    grid-template-columns: 36px 1fr;
    gap: 8px;
    background: var(--wz-surface-blue);
    border: 1px solid var(--wz-border-blue);
    border-left: 3px solid var(--wz-green);
    padding: 12px 14px;
    border-radius: 3px;
  }
  .rs1__erst-text h3 {
    font-size: 14px !important;
    margin: 0 0 4px;
    color: var(--wz-ink) !important;
  }
  .rs1__erst-text p {
    font-size: 13px;
    color: var(--wz-ink-3);
    margin: 0;
    line-height: 1.45;
  }

  .rs1__submit {
    background: #fff;
    border: 1px solid var(--wz-border);
    border-left: 3px solid var(--wz-blue);
    padding: 14px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    border-radius: 3px;
  }
  .rs1__submit-extra {
    display: flex;
    align-items: center;
  }
  .rs1__submit-btn {
    align-self: flex-start;
    height: 52px !important;
    font-size: 16px !important;
    font-weight: 700 !important;
    text-transform: none !important;
    letter-spacing: 0 !important;
  }

  .rs1__hints {
    background: var(--wz-surface-3);
    border: 1px solid var(--wz-border);
    padding: 12px 14px;
    border-radius: 3px;
  }
  .rs1__hints h3 {
    margin: 0 0 6px;
    font-size: 14px !important;
    color: var(--wz-ink) !important;
  }

  .hl-list {
    margin: 0;
    padding-left: 18px;
    list-style: disc outside;
  }
  .hl-list li {
    font-size: 13px;
    color: var(--wz-ink-2);
    line-height: 1.5;
    border-bottom: 1px dashed var(--wz-border-3);
    padding: 4px 0;
  }
  .hl-list li:last-child {
    border-bottom: none;
  }
  .hl-list li::marker {
    color: var(--wz-blue);
  }

  :deep(.v-field) {
    border-radius: 3px !important;
  }
  :deep(.v-field__outline) {
    --v-field-border-opacity: 0.6;
  }

  @media (max-width: 780px) {
    .rs1__form {
      gap: 8px;
    }
    .qrow {
      grid-template-columns: 1fr;
      gap: 8px;
      padding: 10px 12px;
    }
    .qsub {
      padding-left: 10px;
      margin-left: 2px;
    }
    .qtoggle {
      align-self: stretch;
    }
    .qtoggle :deep(.v-btn-toggle) {
      width: 100%;
    }
    .qtoggle :deep(.v-btn) {
      flex: 1 1 0;
      min-width: 0 !important;
    }
    .qnote {
      padding: 10px 12px;
    }
    .rs1__erst {
      padding: 10px 12px;
    }
    .rs1__submit {
      padding: 12px;
    }
    .rs1__submit-btn {
      width: 100%;
      align-self: stretch;
    }
  }
</style>
